import {OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {FieldViewerComponent} from "../../../app/shared/field-viewer/field-viewer.component";
import {FollowNegozio, getInitials, IsNegozioPref, IsntNegozioPref, UnfollowNegozio} from "./Segui";
import {Catalogo} from "./Catalogo";
import {ApiPathsService} from "../../../app/api-paths.service";
import {DynamicListComponent} from "../../../app/shared/dynamic-list/dynamic-list.component";
import {DynamicEditComponent} from "../../../app/shared/dynamic-edit/dynamic-edit.component";

function dettaglio_negozio() {
  var OBJ: OggettoConfig = {
    Id: "dettaglio_negozio",
    MenuItems:[],
    EditView:"Page",
    RestRoute: '/anagrafica/clienti',
    PrintHeaders:[],
    DisableEdit:true,
    noCardBody:true,
    editClass: 'negozioWrap',
    campi:[
      CampoAggiuntivo.Html("", (negozio, component: FieldViewerComponent)=>{
        return `
        <div class="neg-header">
        <div class="neg-hero">
          <div class="neg-logo">${getInitials(negozio.nominativo)}</div>
          <div class="neg-info">
            <div class="neg-name-row">
              <h1 class="neg-name">${negozio.nominativo}</h1>
             <!-- <span class="neg-rating" style="cursor:pointer;" title="Vedi recensioni">⭐ 4.8 <span style="font-size:12px;color:var(--muted);font-weight:600;">(142 recensioni)</span></span>-->
            </div>
            <p class="neg-desc">${negozio.note ?? ''}</p>
          </div>
          <div class="neg-follow-col">
            <span class="neg-follower-cnt">142 Follower</span>
          </div>
        </div>
      </div>
        `;
      }, ()=>true, {
        azioni:[
          {
            label: "+ Segui",
            type:'func',
            func: (field, bottone, campo, Oggetto, api: ApiPathsService, component:FieldViewerComponent)=>{
              FollowNegozio(Oggetto, api, component.toastService);
            },
            class:'neg-follow-btn',
            hideif:{func: IsntNegozioPref}
          },
          {
            label: "✓ Seguito",
            type:'func',
            func: (field, bottone, campo, Oggetto, api: ApiPathsService, component:FieldViewerComponent)=>{
              UnfollowNegozio(Oggetto, api, component.toastService);
            },
            class:'neg-follow-btn following',
            hideif:{func: IsNegozioPref}
          }

        ]
      }),
      CampoAggiuntivo.Crud("", ProdottiNegozio()),
    ]
  }
  return OBJ;
}

function ProdottiNegozio() {
  var obj: OggettoConfig ={
  ...Catalogo(),
   Id:'prodotti_negozio',
    Filters: null,
    sidebarListSections: null,
    ListDefaultFilterFunc: (component)=>{
      component.activeRoute.params.subscribe(data=>{
        console.log('data', data);
        component.filtro = {...component.filtro, negozio: data.id}
      });
      return {};
    }

 }

  return obj
}

export var dettaglio_negozioEnv = () => {
  var env: any = {
    Modules: {
      "dettaglio_negozio": true
    },
    Cruds: [dettaglio_negozio(), ProdottiNegozio()],
    Menu: [...dettaglio_negozio().MenuItems]
  }
  return env;

}
